const keywords = [
  "truck parking Charlotte",
  "truck parking NC",
  "24/7 truck parking",
  "safe truck parking",
  "book truck parking online",
  "book truck parking online Charlotte",
  "book truck parking online NC",
  "truck parking rates",
  "truck parking prices",
  "truck parking cost",
  "truck parking fees",
  "truck parking availability",
  "truck parking reservations",
  "truck parking booking",
  "truck parking booking online",
  "truck parking booking Charlotte",
  "truck parking booking NC",
  "truck parking booking rates",
  "truck parking booking prices",
  "truck parking booking cost",
  "truck parking booking fees",
  "truck parking booking availability",
  "truck parking booking reservations",
  "truck parking booking online Charlotte",
  "truck parking booking online NC",
  "truck parking booking near me",
  "truck parking booking with security",
  "truck parking booking with surveillance",
  "truck parking booking with amenities",
  "truck parking booking with restrooms",
  "truck parking booking with showers",
  "truck parking booking with Wi-Fi",
  "truck parking booking with fuel station",
  "truck parking booking with maintenance services",
  "truck parking booking with electric hookups",
  "truck parking booking with food services",
  "truck parking booking with lounge area",
  "truck parking booking with laundry facilities",
  "truck parking booking with convenience store",
  "truck parking booking with repair services",
  "truck parking booking with tire services",
  "truck parking booking with towing services",
  "truck parking booking with emergency services",
  "truck parking booking with medical services",
  "truck parking booking with truck wash",
  "truck parking booking with truck scales",
  "truck parking booking with weigh station",
  "truck parking booking with truck stop",
  "truck parking booking with diesel fuel",
  "truck parking booking with DEF",
  "truck parking booking with propane",
  "truck parking booking with RV parking",
  "secure truck parking",
  "affordable truck parking",
  "gated truck parking",
  "truck parking reservations",
  "truck parking lot",
  "truck parking near me",
  "semi truck parking near me",
  "overnight truck parking",
  "long-term truck parking",
  "short-term truck parking",
  "truck parking with security",
  "truck parking with surveillance",
  "truck parking with amenities",
  "truck parking with restrooms",
  "truck parking with showers",
  "truck parking with Wi-Fi",
  "truck parking with fuel station",
  "truck parking with maintenance services",
  "truck parking with electric hookups",
  "truck parking with food services",
  "truck parking with lounge area",
  "truck parking with laundry facilities",
  "truck parking with convenience store",
  "truck parking with repair services",
  "truck parking with tire services",
  "truck parking with towing services",
  "truck parking with emergency services",
  "truck parking with medical services",
  "truck parking with truck wash",
  "truck parking with truck scales",
  "truck parking with weigh station",
  "truck parking with truck stop",
  "truck parking with diesel fuel",
  "truck parking with DEF",
  "truck parking with propane",
  "truck parking with RV parking",
  "truck parking with trailer parking",
  "truck parking with oversized parking",
  "truck parking with refrigerated parking",
  "truck parking with dry van parking",
  "truck parking with flatbed parking",
  "truck parking with tanker parking",
  "truck parking with car hauler parking",
  "truck parking with livestock parking",
  "truck parking with hazardous materials parking",
  "truck parking with oversized load parking",
  "truck parking with heavy haul parking",
  "truck parking with specialized equipment parking",
  "truck parking with fleet parking",
  "truck parking with company parking",
  "truck parking with owner-operator parking",
  "truck parking with independent driver parking",
  "truck parking with team driver parking",
  "truck parking with solo driver parking",
  "truck parking with local driver parking",
  "truck parking with regional driver parking",
  "truck parking with long-haul driver parking",
  "truck parking with OTR driver parking",
  "truck parking with dedicated driver parking",
  "truck parking with lease driver parking",
  "truck parking with company driver parking",
  "truck parking with private fleet parking",
  "truck parking with public fleet parking",
  "truck parking with government fleet parking",
  "truck parking with military fleet parking",
  "truck parking with school bus parking",
  "truck parking with charter bus parking",
  "truck parking with tour bus parking",
  "truck parking with shuttle bus parking",
  "truck parking with transit bus parking",
  "truck parking with motorcoach parking",
  "truck parking with limousine parking",
  "truck parking with taxi parking",
  "truck parking with rideshare parking",
  "truck parking with delivery van parking",
  "truck parking with courier van parking",
  "truck parking with service van parking",
  "truck parking with utility van parking",
  "truck parking with construction vehicle parking",
  "truck parking with heavy equipment parking",
  "truck parking with agricultural vehicle parking",
  "truck parking with forestry vehicle parking",
  "truck parking with mining vehicle parking",
  "truck parking with oilfield vehicle parking",
  "truck parking with logging vehicle parking",
  "truck parking with snow removal vehicle parking",
  "truck parking with street sweeper parking",
  "truck parking with garbage truck parking",
  "truck parking with recycling truck parking",
  "truck parking with septic truck parking",
  "truck parking with vacuum truck parking",
  "truck parking with tanker truck parking",
  "truck parking with fuel truck parking",
  "truck parking with water truck parking",
  "truck parking with chemical truck parking",
  "truck parking with cement truck parking",
  "truck parking with concrete truck parking",
  "truck parking with asphalt truck parking",
  "truck parking with dump truck parking",
  "truck parking with flatbed truck parking",
  "truck parking with lowboy truck parking",
  "truck parking with step deck truck parking",
  "truck parking with double drop truck parking",
  "truck parking with RGN truck parking",
  "truck parking with stretch trailer parking",
  "truck parking with extendable trailer parking",
  "truck parking with multi-axle trailer parking",
  "truck parking with heavy haul trailer parking",
  "truck parking with specialized trailer parking",
  "truck parking with equipment trailer parking",
  "truck parking with utility trailer parking",
  "truck parking with cargo trailer parking",
  "truck parking with enclosed trailer parking",
  "truck parking with open trailer parking",
  "truck parking with car trailer parking",
  "truck parking with motorcycle trailer parking",
  "truck parking with boat trailer parking",
  "truck parking with RV trailer parking",
  "truck parking with camper trailer parking",
  "truck parking with travel trailer parking",
  "truck parking with fifth wheel trailer parking",
  "truck parking with gooseneck trailer parking",
  "truck parking with bumper pull trailer parking",
  "truck parking with pintle hitch trailer parking",
  "truck parking with tow dolly parking",
  "truck parking with car hauler parking",
  "truck parking with motorcycle hauler parking",
  "truck parking with boat hauler parking",
  "truck parking with RV hauler parking",
  "truck parking with camper hauler parking",
  "truck parking with travel trailer hauler parking",
  "truck parking with fifth wheel hauler parking",
  "truck parking with gooseneck hauler parking",
  "truck parking with bumper pull hauler parking",
  "truck parking with pintle hitch hauler parking",
  "truck parking with tow dolly hauler parking",
  "truck parking with car carrier parking",
  "truck parking with motorcycle carrier parking",
  "truck parking with boat carrier parking",
  "truck parking with RV carrier parking",
  "truck parking with camper carrier parking",
  "truck parking with travel trailer carrier parking",
  "truck parking with fifth wheel carrier parking",
  "truck parking with gooseneck carrier parking",
  "truck parking with bumper pull carrier parking",
  "truck parking with pintle hitch carrier parking",
  "truck parking with tow dolly carrier parking",
  "truck parking charlotte", "secure truck parking", 
  "gated truck parking", "affordable truck parking",
  "truck parking rates", "daily truck parking", 
  "weekly truck parking", "monthly truck parking",
  "truck parking with caroMeck diesel pm",
  "truck parking club",
];

export default keywords;